import React, { useState } from 'react';
import '../styles/ContactForm.css';

const ContactForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null); // Added this missing state declaration

  const validateForm = () => {
    let tempErrors = {};
    
    if (!formData.name.trim()) {
      tempErrors.name = "Name is required";
    }
    
    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Email address is invalid";
    }
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      setSubmitError(null); // Reset any previous errors
      
      // Add small delay to show loading state
      setTimeout(() => {
        try {
          onSubmit(formData);
        } catch (error) {
          setSubmitError('There was a problem submitting the form. Please try again.');
          console.error('Form submission error:', error);
        } finally {
          setIsSubmitting(false);
        }
      }, 600);
    }
  };

  return (
    <section className="contact-form" id="contact-section">
      <div className="container">
        <h2>Ready to <span className="highlight">Transform Your Business</span> with AI?</h2>
        <p className="section-subtitle">
          Take the first step toward business automation and get free access today
        </p>
        
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? 'error' : ''}
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? 'error' : ''}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
            
            <div className="form-group">
              <label htmlFor="message">What are you looking to automate?</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className={errors.message ? 'error' : ''}
              />
              {errors.message && <span className="error-message">{errors.message}</span>}
            </div>
            
            {submitError && (
              <div className="error-message form-error">{submitError}</div>
            )}
            
            <button 
              type="submit" 
              className="submit-button" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Processing...' : 'Get Free Access'}
            </button>
          </form>
          
          <div className="form-sidebar">
            <div className="form-feature">
              <div className="feature-icon">🔒</div>
              <div className="feature-text">
                <h4>Secure & Confidential</h4>
                <p>Your information is protected and never shared</p>
              </div>
            </div>
            
            <div className="form-feature">
              <div className="feature-icon">⚡</div>
              <div className="feature-text">
                <h4>Quick Setup</h4>
                <p>Be up and running in minutes, not days</p>
              </div>
            </div>
            
            <div className="form-feature">
              <div className="feature-icon">💯</div>
              <div className="feature-text">
                <h4>Full Access</h4>
                <p>Get complete access to all 100+ AI agents</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
